import React from "react"
import { makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"

import SEO from "./seo"

export default function TitrePage({ titre }) {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <>
      <SEO title={t(titre)} />
      <div className={classes.wrapper}>
        <h1 className={classes.titre}>{t(titre)}</h1>
      </div>
    </>
  )
}

const useStyles = makeStyles(theme => ({
  wrapper: {
    backgroundColor: theme.palette.bgwhite,
    marginBottom: "2rem",
    padding: "2rem 0",
  },
  titre: {
    textAlign: "center",
    margin: "20px 0 15px",
    lineHeight: "40px",
    fontSize: "40px",
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
}))
